module.exports = __webpack_public_path__ + "img/icon_appstore.426e71a6.png";